import F, { useState as k, useEffect as E, useMemo as L, forwardRef as le, useRef as Z, useCallback as T, createElement as Ln, Children as Bn } from "react";
import { useFloating as Ct, useTransitionStyles as St, offset as se, flip as ke, size as Dn } from "@floating-ui/react";
import { Group as Pe, Menu as H, Button as Ie, Stack as Oe, Text as ie, Tooltip as _n, ActionIcon as jt, Popover as X, TextInput as Ht, FileInput as wt, Tabs as Q, LoadingOverlay as Pn, Box as Tt, Badge as In, Loader as On, MantineProvider as An } from "@mantine/core";
import { mergeCSSClasses as ce, formatKeyboardShortcut as P, isStyledTextInlineContent as Fn, imageToolbarPluginKey as Nn, BlockNoteEditor as zn, inheritedProps as Zn, camelToDataKebab as pt, createStronglyTypedTiptapNode as Mt, propsToAttributes as Et, getParseRules as Un, getBlockFromPos as $n, createInternalBlockSpec as Wn, addInlineContentKeyboardShortcuts as Yn, getInlineContentParseRules as Kn, nodeToCustomInlineContent as ut, addInlineContentAttributes as qn, createInternalInlineContentSpec as Gn, stylePropsToAttributes as Jn, getStyleParseRules as Qn, addStyleAttributes as Xn, createInternalStyleSpec as er } from "@blocknote/core";
import { EditorContent as tr, NodeViewWrapper as Rt, ReactNodeViewRenderer as Vt, NodeViewContent as Lt, Mark as nr } from "@tiptap/react";
import rr from "use-prefers-color-scheme";
import or, { flushSync as ir } from "react-dom";
var Ve = { exports: {} }, re = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ft;
function ar() {
  if (ft)
    return re;
  ft = 1;
  var e = F, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(l, c, g) {
    var h, m = {}, B = null, p = null;
    g !== void 0 && (B = "" + g), c.key !== void 0 && (B = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (h in c)
      i.call(c, h) && !s.hasOwnProperty(h) && (m[h] = c[h]);
    if (l && l.defaultProps)
      for (h in c = l.defaultProps, c)
        m[h] === void 0 && (m[h] = c[h]);
    return { $$typeof: t, type: l, key: B, ref: p, props: m, _owner: a.current };
  }
  return re.Fragment = n, re.jsx = u, re.jsxs = u, re;
}
var oe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gt;
function lr() {
  return gt || (gt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = F, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), B = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), Y = Symbol.iterator, I = "@@iterator";
    function K(r) {
      if (r === null || typeof r != "object")
        return null;
      var d = Y && r[Y] || r[I];
      return typeof d == "function" ? d : null;
    }
    var q = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(r) {
      {
        for (var d = arguments.length, f = new Array(d > 1 ? d - 1 : 0), b = 1; b < d; b++)
          f[b - 1] = arguments[b];
        Qt("error", r, f);
      }
    }
    function Qt(r, d, f) {
      {
        var b = q.ReactDebugCurrentFrame, y = b.getStackAddendum();
        y !== "" && (d += "%s", f = f.concat([y]));
        var j = f.map(function(v) {
          return String(v);
        });
        j.unshift("Warning: " + d), Function.prototype.apply.call(console[r], console, j);
      }
    }
    var Xt = !1, en = !1, tn = !1, nn = !1, rn = !1, Ne;
    Ne = Symbol.for("react.module.reference");
    function on(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === s || rn || r === a || r === g || r === h || nn || r === p || Xt || en || tn || typeof r == "object" && r !== null && (r.$$typeof === B || r.$$typeof === m || r.$$typeof === u || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Ne || r.getModuleId !== void 0));
    }
    function an(r, d, f) {
      var b = r.displayName;
      if (b)
        return b;
      var y = d.displayName || d.name || "";
      return y !== "" ? f + "(" + y + ")" : f;
    }
    function ze(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case a:
          return "StrictMode";
        case g:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var d = r;
            return ze(d) + ".Consumer";
          case u:
            var f = r;
            return ze(f._context) + ".Provider";
          case c:
            return an(r, r.render, "ForwardRef");
          case m:
            var b = r.displayName || null;
            return b !== null ? b : O(r.type) || "Memo";
          case B: {
            var y = r, j = y._payload, v = y._init;
            try {
              return O(v(j));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = Object.assign, te = 0, Ze, Ue, $e, We, Ye, Ke, qe;
    function Ge() {
    }
    Ge.__reactDisabledLog = !0;
    function ln() {
      {
        if (te === 0) {
          Ze = console.log, Ue = console.info, $e = console.warn, We = console.error, Ye = console.group, Ke = console.groupCollapsed, qe = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: Ge,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: $({}, r, {
              value: Ze
            }),
            info: $({}, r, {
              value: Ue
            }),
            warn: $({}, r, {
              value: $e
            }),
            error: $({}, r, {
              value: We
            }),
            group: $({}, r, {
              value: Ye
            }),
            groupCollapsed: $({}, r, {
              value: Ke
            }),
            groupEnd: $({}, r, {
              value: qe
            })
          });
        }
        te < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ce = q.ReactCurrentDispatcher, Se;
    function ue(r, d, f) {
      {
        if (Se === void 0)
          try {
            throw Error();
          } catch (y) {
            var b = y.stack.trim().match(/\n( *(at )?)/);
            Se = b && b[1] || "";
          }
        return `
` + Se + r;
      }
    }
    var je = !1, fe;
    {
      var cn = typeof WeakMap == "function" ? WeakMap : Map;
      fe = new cn();
    }
    function Je(r, d) {
      if (!r || je)
        return "";
      {
        var f = fe.get(r);
        if (f !== void 0)
          return f;
      }
      var b;
      je = !0;
      var y = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var j;
      j = Ce.current, Ce.current = null, ln();
      try {
        if (d) {
          var v = function() {
            throw Error();
          };
          if (Object.defineProperty(v.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(v, []);
            } catch (A) {
              b = A;
            }
            Reflect.construct(r, [], v);
          } else {
            try {
              v.call();
            } catch (A) {
              b = A;
            }
            r.call(v.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (A) {
            b = A;
          }
          r();
        }
      } catch (A) {
        if (A && b && typeof A.stack == "string") {
          for (var x = A.stack.split(`
`), V = b.stack.split(`
`), w = x.length - 1, M = V.length - 1; w >= 1 && M >= 0 && x[w] !== V[M]; )
            M--;
          for (; w >= 1 && M >= 0; w--, M--)
            if (x[w] !== V[M]) {
              if (w !== 1 || M !== 1)
                do
                  if (w--, M--, M < 0 || x[w] !== V[M]) {
                    var D = `
` + x[w].replace(" at new ", " at ");
                    return r.displayName && D.includes("<anonymous>") && (D = D.replace("<anonymous>", r.displayName)), typeof r == "function" && fe.set(r, D), D;
                  }
                while (w >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        je = !1, Ce.current = j, sn(), Error.prepareStackTrace = y;
      }
      var J = r ? r.displayName || r.name : "", dt = J ? ue(J) : "";
      return typeof r == "function" && fe.set(r, dt), dt;
    }
    function dn(r, d, f) {
      return Je(r, !1);
    }
    function un(r) {
      var d = r.prototype;
      return !!(d && d.isReactComponent);
    }
    function ge(r, d, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Je(r, un(r));
      if (typeof r == "string")
        return ue(r);
      switch (r) {
        case g:
          return ue("Suspense");
        case h:
          return ue("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return dn(r.render);
          case m:
            return ge(r.type, d, f);
          case B: {
            var b = r, y = b._payload, j = b._init;
            try {
              return ge(j(y), d, f);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Qe = {}, Xe = q.ReactDebugCurrentFrame;
    function be(r) {
      if (r) {
        var d = r._owner, f = ge(r.type, r._source, d ? d.type : null);
        Xe.setExtraStackFrame(f);
      } else
        Xe.setExtraStackFrame(null);
    }
    function fn(r, d, f, b, y) {
      {
        var j = Function.call.bind(he);
        for (var v in r)
          if (j(r, v)) {
            var x = void 0;
            try {
              if (typeof r[v] != "function") {
                var V = Error((b || "React class") + ": " + f + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw V.name = "Invariant Violation", V;
              }
              x = r[v](d, v, b, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (w) {
              x = w;
            }
            x && !(x instanceof Error) && (be(y), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", b || "React class", f, v, typeof x), be(null)), x instanceof Error && !(x.message in Qe) && (Qe[x.message] = !0, be(y), R("Failed %s type: %s", f, x.message), be(null));
          }
      }
    }
    var gn = Array.isArray;
    function He(r) {
      return gn(r);
    }
    function hn(r) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, f = d && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function bn(r) {
      try {
        return et(r), !1;
      } catch {
        return !0;
      }
    }
    function et(r) {
      return "" + r;
    }
    function tt(r) {
      if (bn(r))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", hn(r)), et(r);
    }
    var ne = q.ReactCurrentOwner, mn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, nt, rt, we;
    we = {};
    function xn(r) {
      if (he.call(r, "ref")) {
        var d = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function vn(r) {
      if (he.call(r, "key")) {
        var d = Object.getOwnPropertyDescriptor(r, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function kn(r, d) {
      if (typeof r.ref == "string" && ne.current && d && ne.current.stateNode !== d) {
        var f = O(ne.current.type);
        we[f] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', O(ne.current.type), r.ref), we[f] = !0);
      }
    }
    function yn(r, d) {
      {
        var f = function() {
          nt || (nt = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function Cn(r, d) {
      {
        var f = function() {
          rt || (rt = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var Sn = function(r, d, f, b, y, j, v) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: r,
        key: d,
        ref: f,
        props: v,
        // Record the component responsible for creating this element.
        _owner: j
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: b
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function jn(r, d, f, b, y) {
      {
        var j, v = {}, x = null, V = null;
        f !== void 0 && (tt(f), x = "" + f), vn(d) && (tt(d.key), x = "" + d.key), xn(d) && (V = d.ref, kn(d, y));
        for (j in d)
          he.call(d, j) && !mn.hasOwnProperty(j) && (v[j] = d[j]);
        if (r && r.defaultProps) {
          var w = r.defaultProps;
          for (j in w)
            v[j] === void 0 && (v[j] = w[j]);
        }
        if (x || V) {
          var M = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          x && yn(v, M), V && Cn(v, M);
        }
        return Sn(r, x, V, y, b, ne.current, v);
      }
    }
    var Te = q.ReactCurrentOwner, ot = q.ReactDebugCurrentFrame;
    function G(r) {
      if (r) {
        var d = r._owner, f = ge(r.type, r._source, d ? d.type : null);
        ot.setExtraStackFrame(f);
      } else
        ot.setExtraStackFrame(null);
    }
    var pe;
    pe = !1;
    function Me(r) {
      return typeof r == "object" && r !== null && r.$$typeof === t;
    }
    function it() {
      {
        if (Te.current) {
          var r = O(Te.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      {
        if (r !== void 0) {
          var d = r.fileName.replace(/^.*[\\\/]/, ""), f = r.lineNumber;
          return `

Check your code at ` + d + ":" + f + ".";
        }
        return "";
      }
    }
    var at = {};
    function wn(r) {
      {
        var d = it();
        if (!d) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (d = `

Check the top-level render call using <` + f + ">.");
        }
        return d;
      }
    }
    function lt(r, d) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = wn(d);
        if (at[f])
          return;
        at[f] = !0;
        var b = "";
        r && r._owner && r._owner !== Te.current && (b = " It was passed a child from " + O(r._owner.type) + "."), G(r), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, b), G(null);
      }
    }
    function st(r, d) {
      {
        if (typeof r != "object")
          return;
        if (He(r))
          for (var f = 0; f < r.length; f++) {
            var b = r[f];
            Me(b) && lt(b, d);
          }
        else if (Me(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var y = K(r);
          if (typeof y == "function" && y !== r.entries)
            for (var j = y.call(r), v; !(v = j.next()).done; )
              Me(v.value) && lt(v.value, d);
        }
      }
    }
    function Tn(r) {
      {
        var d = r.type;
        if (d == null || typeof d == "string")
          return;
        var f;
        if (typeof d == "function")
          f = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === m))
          f = d.propTypes;
        else
          return;
        if (f) {
          var b = O(d);
          fn(f, r.props, "prop", b, r);
        } else if (d.PropTypes !== void 0 && !pe) {
          pe = !0;
          var y = O(d);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", y || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function pn(r) {
      {
        for (var d = Object.keys(r.props), f = 0; f < d.length; f++) {
          var b = d[f];
          if (b !== "children" && b !== "key") {
            G(r), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", b), G(null);
            break;
          }
        }
        r.ref !== null && (G(r), R("Invalid attribute `ref` supplied to `React.Fragment`."), G(null));
      }
    }
    function ct(r, d, f, b, y, j) {
      {
        var v = on(r);
        if (!v) {
          var x = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var V = Hn(y);
          V ? x += V : x += it();
          var w;
          r === null ? w = "null" : He(r) ? w = "array" : r !== void 0 && r.$$typeof === t ? (w = "<" + (O(r.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : w = typeof r, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", w, x);
        }
        var M = jn(r, d, f, y, j);
        if (M == null)
          return M;
        if (v) {
          var D = d.children;
          if (D !== void 0)
            if (b)
              if (He(D)) {
                for (var J = 0; J < D.length; J++)
                  st(D[J], r);
                Object.freeze && Object.freeze(D);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              st(D, r);
        }
        return r === i ? pn(M) : Tn(M), M;
      }
    }
    function Mn(r, d, f) {
      return ct(r, d, f, !0);
    }
    function En(r, d, f) {
      return ct(r, d, f, !1);
    }
    var Rn = En, Vn = Mn;
    oe.Fragment = i, oe.jsx = Rn, oe.jsxs = Vn;
  }()), oe;
}
process.env.NODE_ENV === "production" ? Ve.exports = ar() : Ve.exports = lr();
var o = Ve.exports;
function ee(e) {
  const [t, n] = k();
  return E(() => e((i) => {
    n({ ...i });
  }), [e]), t;
}
function de(e, t, n, i) {
  const { refs: a, update: s, context: u, floatingStyles: l } = Ct({
    open: e,
    ...i
  }), { isMounted: c, styles: g } = St(u);
  return E(() => {
    s();
  }, [t, s]), E(() => {
    t !== null && a.setReference({
      getBoundingClientRect: () => t
    });
  }, [t, a]), L(
    () => ({
      isMounted: c,
      ref: a.setFloating,
      style: {
        display: "flex",
        ...g,
        ...l,
        zIndex: n
      }
    }),
    [l, c, a.setFloating, g, n]
  );
}
function Bt(e, t) {
  E(() => (e._tiptapEditor.on("update", t), () => {
    e._tiptapEditor.off("update", t);
  }), [t, e._tiptapEditor]);
}
function Dt(e, t) {
  E(() => (e._tiptapEditor.on("selectionUpdate", t), () => {
    e._tiptapEditor.off("selectionUpdate", t);
  }), [t, e._tiptapEditor]);
}
function U(e, t) {
  Bt(e, t), Dt(e, t);
}
const Ae = le((e, t) => {
  const { className: n, children: i, ...a } = e;
  return /* @__PURE__ */ o.jsx(
    Pe,
    {
      className: ce("bn-toolbar", n || ""),
      ref: t,
      ...a,
      children: i
    }
  );
});
var _t = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, ht = F.createContext && F.createContext(_t), z = globalThis && globalThis.__assign || function() {
  return z = Object.assign || function(e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, z.apply(this, arguments);
}, sr = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, i = Object.getOwnPropertySymbols(e); a < i.length; a++)
      t.indexOf(i[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[a]) && (n[i[a]] = e[i[a]]);
  return n;
};
function Pt(e) {
  return e && e.map(function(t, n) {
    return F.createElement(t.tag, z({
      key: n
    }, t.attr), Pt(t.child));
  });
}
function S(e) {
  return function(t) {
    return F.createElement(cr, z({
      attr: z({}, e.attr)
    }, t), Pt(e.child));
  };
}
function cr(e) {
  var t = function(n) {
    var i = e.attr, a = e.size, s = e.title, u = sr(e, ["attr", "size", "title"]), l = a || n.size || "1em", c;
    return n.className && (c = n.className), e.className && (c = (c ? c + " " : "") + e.className), F.createElement("svg", z({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, i, u, {
      className: c,
      style: z(z({
        color: e.color || n.color
      }, n.style), e.style),
      height: l,
      width: l,
      xmlns: "http://www.w3.org/2000/svg"
    }), s && F.createElement("title", null, s), e.children);
  };
  return ht !== void 0 ? F.createElement(ht.Consumer, null, function(n) {
    return t(n);
  }) : t(_t);
}
function dr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M23 11.9998L15.9289 19.0708L14.5147 17.6566L20.1716 11.9998L14.5147 6.34292L15.9289 4.92871L23 11.9998ZM3.82843 11.9998L9.48528 17.6566L8.07107 19.0708L1 11.9998L8.07107 4.92871L9.48528 6.34292L3.82843 11.9998Z" } }] })(e);
}
function ur(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM5 19H19V21H5V19ZM3 14H21V16H3V14ZM5 9H19V11H5V9Z" } }] })(e);
}
function fr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM3 14H21V16H3V14ZM3 9H21V11H3V9Z" } }] })(e);
}
function gr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H17V21H3V19ZM3 14H21V16H3V14ZM3 9H17V11H3V9Z" } }] })(e);
}
function hr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM7 19H21V21H7V19ZM3 14H21V16H3V14ZM7 9H21V11H7V9Z" } }] })(e);
}
function br(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M8 11H12.5C13.8807 11 15 9.88071 15 8.5C15 7.11929 13.8807 6 12.5 6H8V11ZM18 15.5C18 17.9853 15.9853 20 13.5 20H6V4H12.5C14.9853 4 17 6.01472 17 8.5C17 9.70431 16.5269 10.7981 15.7564 11.6058C17.0979 12.3847 18 13.837 18 15.5ZM8 13V18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H8Z" } }] })(e);
}
function It(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM21.0005 8V20H19.0005L19 10.204L17 10.74V8.67L19.5005 8H21.0005Z" } }] })(e);
}
function Ot(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 8C20.5711 8 22.25 9.67893 22.25 11.75C22.25 12.6074 21.9623 13.3976 21.4781 14.0292L21.3302 14.2102L18.0343 18H22V20H15L14.9993 18.444L19.8207 12.8981C20.0881 12.5908 20.25 12.1893 20.25 11.75C20.25 10.7835 19.4665 10 18.5 10C17.5818 10 16.8288 10.7071 16.7558 11.6065L16.75 11.75H14.75C14.75 9.67893 16.4289 8 18.5 8Z" } }] })(e);
}
function At(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M22 8L21.9984 10L19.4934 12.883C21.0823 13.3184 22.25 14.7728 22.25 16.5C22.25 18.5711 20.5711 20.25 18.5 20.25C16.674 20.25 15.1528 18.9449 14.8184 17.2166L16.7821 16.8352C16.9384 17.6413 17.6481 18.25 18.5 18.25C19.4665 18.25 20.25 17.4665 20.25 16.5C20.25 15.5335 19.4665 14.75 18.5 14.75C18.214 14.75 17.944 14.8186 17.7056 14.9403L16.3992 13.3932L19.3484 10H15V8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z" } }] })(e);
}
function mr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM11 14H21V16H11V14ZM11 9H21V11H11V9ZM3 12.5L7 9V16L3 12.5Z" } }] })(e);
}
function xr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM11 14H21V16H11V14ZM11 9H21V11H11V9ZM7 12.5L3 16V9L7 12.5Z" } }] })(e);
}
function vr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M15 20H7V18H9.92661L12.0425 6H9V4H17V6H14.0734L11.9575 18H15V20Z" } }] })(e);
}
function kr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M17 17H22V19H19V22H17V17ZM7 7H2V5H5V2H7V7ZM18.364 15.5355L16.9497 14.1213L18.364 12.7071C20.3166 10.7545 20.3166 7.58866 18.364 5.63604C16.4113 3.68342 13.2455 3.68342 11.2929 5.63604L9.87868 7.05025L8.46447 5.63604L9.87868 4.22183C12.6123 1.48816 17.0445 1.48816 19.7782 4.22183C22.5118 6.9555 22.5118 11.3877 19.7782 14.1213L18.364 15.5355ZM15.5355 18.364L14.1213 19.7782C11.3877 22.5118 6.9555 22.5118 4.22183 19.7782C1.48816 17.0445 1.48816 12.6123 4.22183 9.87868L5.63604 8.46447L7.05025 9.87868L5.63604 11.2929C3.68342 13.2455 3.68342 16.4113 5.63604 18.364C7.58866 20.3166 10.7545 20.3166 12.7071 18.364L14.1213 16.9497L15.5355 18.364ZM14.8284 7.75736L16.2426 9.17157L9.17157 16.2426L7.75736 14.8284L14.8284 7.75736Z" } }] })(e);
}
function Ft(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M18.3643 15.5353L16.95 14.1211L18.3643 12.7069C20.3169 10.7543 20.3169 7.58847 18.3643 5.63585C16.4116 3.68323 13.2458 3.68323 11.2932 5.63585L9.87898 7.05007L8.46477 5.63585L9.87898 4.22164C12.6127 1.48797 17.0448 1.48797 19.7785 4.22164C22.5121 6.95531 22.5121 11.3875 19.7785 14.1211L18.3643 15.5353ZM15.5358 18.3638L14.1216 19.778C11.388 22.5117 6.9558 22.5117 4.22213 19.778C1.48846 17.0443 1.48846 12.6122 4.22213 9.87849L5.63634 8.46428L7.05055 9.87849L5.63634 11.2927C3.68372 13.2453 3.68372 16.4112 5.63634 18.3638C7.58896 20.3164 10.7548 20.3164 12.7074 18.3638L14.1216 16.9496L15.5358 18.3638ZM14.8287 7.75717L16.2429 9.17139L9.17187 16.2425L7.75766 14.8282L14.8287 7.75717Z" } }] })(e);
}
function Nt(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M8 4H21V6H8V4ZM5 3V6H6V7H3V6H4V4H3V3H5ZM3 14V11.5H5V11H3V10H6V12.5H4V13H6V14H3ZM5 19.5H3V18.5H5V18H3V17H6V21H3V20H5V19.5ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z" } }] })(e);
}
function zt(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M8 4H21V6H8V4ZM4.5 6.5C3.67157 6.5 3 5.82843 3 5C3 4.17157 3.67157 3.5 4.5 3.5C5.32843 3.5 6 4.17157 6 5C6 5.82843 5.32843 6.5 4.5 6.5ZM4.5 13.5C3.67157 13.5 3 12.8284 3 12C3 11.1716 3.67157 10.5 4.5 10.5C5.32843 10.5 6 11.1716 6 12C6 12.8284 5.32843 13.5 4.5 13.5ZM4.5 20.4C3.67157 20.4 3 19.7284 3 18.9C3 18.0716 3.67157 17.4 4.5 17.4C5.32843 17.4 6 18.0716 6 18.9C6 19.7284 5.32843 20.4 4.5 20.4ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z" } }] })(e);
}
function yr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M17.1538 14C17.3846 14.5161 17.5 15.0893 17.5 15.7196C17.5 17.0625 16.9762 18.1116 15.9286 18.867C14.8809 19.6223 13.4335 20 11.5862 20C9.94674 20 8.32335 19.6185 6.71592 18.8555V16.6009C8.23538 17.4783 9.7908 17.917 11.3822 17.917C13.9333 17.917 15.2128 17.1846 15.2208 15.7196C15.2208 15.0939 15.0049 14.5598 14.5731 14.1173C14.5339 14.0772 14.4939 14.0381 14.4531 14H3V12H21V14H17.1538ZM13.076 11H7.62908C7.4566 10.8433 7.29616 10.6692 7.14776 10.4778C6.71592 9.92084 6.5 9.24559 6.5 8.45207C6.5 7.21602 6.96583 6.165 7.89749 5.299C8.82916 4.43299 10.2706 4 12.2219 4C13.6934 4 15.1009 4.32808 16.4444 4.98426V7.13591C15.2448 6.44921 13.9293 6.10587 12.4978 6.10587C10.0187 6.10587 8.77917 6.88793 8.77917 8.45207C8.77917 8.87172 8.99709 9.23796 9.43293 9.55079C9.86878 9.86362 10.4066 10.1135 11.0463 10.3004C11.6665 10.4816 12.3431 10.7148 13.076 11H13.076Z" } }] })(e);
}
function Cr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M13 10V14H19V10H13ZM11 10H5V14H11V10ZM13 19H19V16H13V19ZM11 19V16H5V19H11ZM13 5V8H19V5H13ZM11 5H5V8H11V5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z" } }] })(e);
}
function ae(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M13 6V21H11V6H5V4H19V6H13Z" } }] })(e);
}
function Sr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M8 3V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V3H18V12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12V3H8ZM4 20H20V22H4V20Z" } }] })(e);
}
function jr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z" } }] })(e);
}
function Hr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M20 3C20.5523 3 21 3.44772 21 4V5.757L19 7.757V5H5V13.1L9 9.1005L13.328 13.429L12.0012 14.7562L11.995 18.995L16.2414 19.0012L17.571 17.671L18.8995 19H19V16.242L21 14.242V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM21.7782 7.80761L23.1924 9.22183L15.4142 17L13.9979 16.9979L14 15.5858L21.7782 7.80761ZM15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7Z" } }] })(e);
}
function wr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V12L17.206 8.207L11.2071 14.2071L9.79289 12.7929L15.792 6.793L12 3H21Z" } }] })(e);
}
function W(e) {
  const [t, n] = k(
    () => {
      var i;
      return ((i = e.getSelection()) == null ? void 0 : i.blocks) || [e.getTextCursorPosition().block];
    }
  );
  return U(
    e,
    () => {
      var i;
      return n(
        ((i = e.getSelection()) == null ? void 0 : i.blocks) || [e.getTextCursorPosition().block]
      );
    }
  ), t;
}
function Le(e) {
  return S({ tag: "svg", attr: { version: "1.2", baseProfile: "tiny", viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M16.972 6.251c-.967-.538-2.185-.188-2.72.777l-3.713 6.682-2.125-2.125c-.781-.781-2.047-.781-2.828 0-.781.781-.781 2.047 0 2.828l4 4c.378.379.888.587 1.414.587l.277-.02c.621-.087 1.166-.46 1.471-1.009l5-9c.537-.966.189-2.183-.776-2.72z" } }] })(e);
}
function Tr(e) {
  const t = e.icon;
  return /* @__PURE__ */ o.jsx(
    H.Item,
    {
      onClick: e.onClick,
      leftSection: t && /* @__PURE__ */ o.jsx(t, { size: 16 }),
      rightSection: e.isSelected ? /* @__PURE__ */ o.jsx(Le, { size: 20, className: "bn-tick-icon" }) : (
        // Ensures space for tick even if item isn't currently selected.
        /* @__PURE__ */ o.jsx("div", { className: "bn-tick-space" })
      ),
      disabled: e.isDisabled,
      children: e.text
    },
    e.text
  );
}
function pr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z", clipRule: "evenodd" } }] })(e);
}
function Mr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z", clipRule: "evenodd" } }] })(e);
}
const Er = le((e, t) => {
  const n = e.icon;
  return /* @__PURE__ */ o.jsx(
    Ie,
    {
      leftSection: n && /* @__PURE__ */ o.jsx(n, { size: 16 }),
      rightSection: /* @__PURE__ */ o.jsx(pr, {}),
      size: "xs",
      variant: "subtle",
      disabled: e.isDisabled,
      onClick: e.onClick,
      ref: t,
      children: e.text
    }
  );
});
function Fe() {
  const e = Z(null);
  return {
    ref: e,
    updateMaxHeight: () => {
      setTimeout(() => {
        if (e.current && e.current.childElementCount > 0) {
          e.current.firstElementChild.style.maxHeight = "none";
          const t = e.current.firstElementChild.getBoundingClientRect();
          e.current.firstElementChild.style.maxHeight = `${Math.min(
            t.top >= 0 ? window.innerHeight - t.top - 20 : t.bottom - 20
          )}px`;
        }
      }, 10);
    }
  };
}
function Rr(e) {
  const t = e.items.filter((a) => a.isSelected)[0], { ref: n, updateMaxHeight: i } = Fe();
  return t ? /* @__PURE__ */ o.jsxs(
    H,
    {
      withinPortal: !1,
      transitionProps: {
        exitDuration: 0
      },
      disabled: e.isDisabled,
      onOpen: i,
      children: [
        /* @__PURE__ */ o.jsx(H.Target, { children: /* @__PURE__ */ o.jsx(
          Er,
          {
            text: t.text,
            icon: t.icon,
            isDisabled: t.isDisabled
          }
        ) }),
        /* @__PURE__ */ o.jsx("div", { ref: n, children: /* @__PURE__ */ o.jsx(H.Dropdown, { children: e.items.map((a) => /* @__PURE__ */ o.jsx(Tr, { ...a }, a.text)) }) })
      ]
    }
  ) : null;
}
const Vr = [
  {
    name: "Paragraph",
    type: "paragraph",
    icon: ae,
    isSelected: (e) => e.type === "paragraph"
  },
  {
    name: "Heading 1",
    type: "heading",
    props: { level: 1 },
    icon: It,
    isSelected: (e) => e.type === "heading" && "level" in e.props && e.props.level === 1
  },
  {
    name: "Heading 2",
    type: "heading",
    props: { level: 2 },
    icon: Ot,
    isSelected: (e) => e.type === "heading" && "level" in e.props && e.props.level === 2
  },
  {
    name: "Heading 3",
    type: "heading",
    props: { level: 3 },
    icon: At,
    isSelected: (e) => e.type === "heading" && "level" in e.props && e.props.level === 3
  },
  {
    name: "Bullet List",
    type: "bulletListItem",
    icon: zt,
    isSelected: (e) => e.type === "bulletListItem"
  },
  {
    name: "Numbered List",
    type: "numberedListItem",
    icon: Nt,
    isSelected: (e) => e.type === "numberedListItem"
  }
], Lr = (e) => {
  const t = W(e.editor), [n, i] = k(
    e.editor.getTextCursorPosition().block
  ), a = L(() => (e.items || Vr).filter((l) => {
    if (!(l.type in e.editor.blockSchema))
      return !1;
    for (const [c, g] of Object.entries(l.props || {})) {
      const h = e.editor.blockSchema[l.type].propSchema;
      if (!(c in h) || h[c].values !== void 0 && !h[c].values.includes(g))
        return !1;
    }
    return !0;
  }), [e.editor, e.items]), s = L(
    () => a.find((l) => l.type === n.type) !== void 0,
    [n.type, a]
  ), u = L(() => {
    const l = (c) => {
      e.editor.focus();
      for (const g of t)
        e.editor.updateBlock(g, {
          type: c.type,
          props: c.props
        });
    };
    return a.map((c) => ({
      text: c.name,
      icon: c.icon,
      onClick: () => l(c),
      isSelected: c.isSelected(n)
    }));
  }, [n, a, e.editor, t]);
  return U(e.editor, () => {
    i(e.editor.getTextCursorPosition().block);
  }), s ? /* @__PURE__ */ o.jsx(Rr, { items: u }) : null;
}, Br = (e) => /* @__PURE__ */ o.jsxs(Oe, { gap: 0, className: "bn-tooltip", children: [
  /* @__PURE__ */ o.jsx(ie, { size: "sm", children: e.mainTooltip }),
  e.secondaryTooltip && /* @__PURE__ */ o.jsx(ie, { size: "xs", children: e.secondaryTooltip })
] }), _ = le(
  (e, t) => {
    const n = e.icon;
    return /* @__PURE__ */ o.jsx(
      _n,
      {
        withinPortal: !1,
        label: /* @__PURE__ */ o.jsx(
          Br,
          {
            mainTooltip: e.mainTooltip,
            secondaryTooltip: e.secondaryTooltip
          }
        ),
        children: e.children ? /* @__PURE__ */ o.jsxs(
          Ie,
          {
            onClick: e.onClick,
            "data-selected": e.isSelected ? "true" : void 0,
            "data-test": e.mainTooltip.slice(0, 1).toLowerCase() + e.mainTooltip.replace(/\s+/g, "").slice(1),
            size: "xs",
            disabled: e.isDisabled || !1,
            ref: t,
            children: [
              n && /* @__PURE__ */ o.jsx(n, {}),
              e.children
            ]
          }
        ) : /* @__PURE__ */ o.jsx(
          jt,
          {
            onClick: e.onClick,
            "data-selected": e.isSelected ? "true" : void 0,
            "data-test": e.mainTooltip.slice(0, 1).toLowerCase() + e.mainTooltip.replace(/\s+/g, "").slice(1),
            size: 30,
            disabled: e.isDisabled || !1,
            ref: t,
            children: n && /* @__PURE__ */ o.jsx(n, {})
          }
        )
      }
    );
  }
), Zt = le(({ className: e, ...t }, n) => /* @__PURE__ */ o.jsx(
  Oe,
  {
    ...t,
    className: ce("bn-toolbar-input-dropdown", e || ""),
    ref: n,
    children: t.children
  }
)), Ut = (e) => {
  const [t, n] = k(!1), i = T(() => {
    n(!1);
  }, []), a = T(() => {
    n(!0);
  }, []);
  return /* @__PURE__ */ o.jsxs(
    X,
    {
      withinPortal: !1,
      onOpen: () => {
        a();
      },
      onClose: () => {
        i();
      },
      zIndex: 1e4,
      ...e,
      children: [
        /* @__PURE__ */ o.jsx(X.Target, { children: e.target }),
        /* @__PURE__ */ o.jsx(X.Dropdown, { children: t ? e.dropdown : null })
      ]
    }
  );
}, Dr = {
  text: Ht,
  file: wt
}, Be = (e) => {
  const t = e.icon, n = Dr[e.type];
  return /* @__PURE__ */ o.jsx(Pe, { children: /* @__PURE__ */ o.jsx(n, { size: "xs", icon: /* @__PURE__ */ o.jsx(t, {}), ...e.inputProps }) });
}, _r = (e) => {
  const t = W(e.editor), n = L(
    () => (
      // Checks if only one block is selected.
      t.length === 1 && // Checks if the selected block is an image.
      t[0].type === "image" && // Checks if the block has a `caption` prop which can take any string
      // value.
      "caption" in e.editor.blockSchema.image.propSchema && typeof e.editor.blockSchema.image.propSchema.caption.default == "string" && e.editor.blockSchema.image.propSchema.caption.values === void 0 && // Checks if the block has a `url` prop which can take any string value.
      "url" in e.editor.blockSchema.image.propSchema && typeof e.editor.blockSchema.image.propSchema.url.default == "string" && e.editor.blockSchema.image.propSchema.url.values === void 0 && // Checks if the `url` prop is not set to an empty string.
      t[0].props.url !== ""
    ),
    [e.editor.blockSchema, t]
  ), [i, a] = k(
    n ? t[0].props.caption : ""
  );
  E(
    () => a(
      n ? t[0].props.caption : ""
    ),
    [t, n]
  );
  const s = T(
    (l) => {
      l.key === "Enter" && (l.preventDefault(), e.editor.updateBlock(t[0], {
        type: "image",
        props: {
          caption: i
        }
      }));
    },
    [i, e.editor, t]
  ), u = T(
    (l) => a(l.currentTarget.value),
    []
  );
  return n ? /* @__PURE__ */ o.jsx(
    Ut,
    {
      target: /* @__PURE__ */ o.jsx(
        _,
        {
          mainTooltip: "Edit Caption",
          icon: ae,
          isSelected: t[0].props.caption !== ""
        }
      ),
      dropdown: /* @__PURE__ */ o.jsx(Zt, { children: /* @__PURE__ */ o.jsx(
        Be,
        {
          type: "text",
          icon: ae,
          inputProps: {
            autoFocus: !0,
            placeholder: "Edit Caption",
            value: i,
            onKeyDown: s,
            onChange: u
          }
        }
      ) })
    }
  ) : null;
}, $t = (e) => {
  const [t, n] = k(
    e.editor.uploadFile !== void 0 ? "upload" : "embed"
  ), [i, a] = k(!1), [s, u] = k(!1);
  E(() => {
    s && setTimeout(() => {
      u(!1);
    }, 3e3);
  }, [s]);
  const l = T(
    (p) => {
      if (p === null)
        return;
      async function Y(I) {
        if (a(!0), e.editor.uploadFile !== void 0)
          try {
            const K = await e.editor.uploadFile(I);
            e.editor.updateBlock(e.block, {
              type: "image",
              props: {
                url: K
              }
            });
          } catch {
            u(!0);
          } finally {
            a(!1);
          }
      }
      Y(p);
    },
    [e.block, e.editor]
  ), [c, g] = k(""), h = T(
    (p) => {
      g(p.currentTarget.value);
    },
    []
  ), m = T(
    (p) => {
      p.key === "Enter" && (p.preventDefault(), e.editor.updateBlock(e.block, {
        type: "image",
        props: {
          url: c
        }
      }));
    },
    [c, e.block, e.editor]
  ), B = T(() => {
    e.editor.updateBlock(e.block, {
      type: "image",
      props: {
        url: c
      }
    });
  }, [c, e.block, e.editor]);
  return /* @__PURE__ */ o.jsx(Ae, { className: "bn-image-toolbar", children: /* @__PURE__ */ o.jsxs(Q, { value: t, onChange: n, children: [
    i && /* @__PURE__ */ o.jsx(Pn, { visible: i }),
    /* @__PURE__ */ o.jsxs(Q.List, { children: [
      e.editor.uploadFile !== void 0 && /* @__PURE__ */ o.jsx(Q.Tab, { value: "upload", "data-test": "upload-tab", children: "Upload" }),
      /* @__PURE__ */ o.jsx(Q.Tab, { value: "embed", "data-test": "embed-tab", children: "Embed" })
    ] }),
    e.editor.uploadFile !== void 0 && /* @__PURE__ */ o.jsx(Q.Panel, { className: "bn-upload-image-panel", value: "upload", children: /* @__PURE__ */ o.jsxs("div", { children: [
      /* @__PURE__ */ o.jsx(
        wt,
        {
          placeholder: "Upload Image",
          size: "xs",
          value: null,
          onChange: l,
          "data-test": "upload-input"
        }
      ),
      s && /* @__PURE__ */ o.jsx(ie, { c: "red", size: "12px", children: "Error: Upload failed" })
    ] }) }),
    /* @__PURE__ */ o.jsx(Q.Panel, { className: "bn-embed-image-panel", value: "embed", children: /* @__PURE__ */ o.jsxs("div", { children: [
      /* @__PURE__ */ o.jsx(
        Ht,
        {
          size: "xs",
          placeholder: "Enter URL",
          value: c,
          onChange: h,
          onKeyDown: m,
          "data-test": "embed-input"
        }
      ),
      /* @__PURE__ */ o.jsx(
        Ie,
        {
          className: "bn-embed-image-button",
          onClick: B,
          size: "xs",
          "data-test": "embed-input-button",
          children: "Embed Image"
        }
      )
    ] }) })
  ] }) });
}, Pr = (e) => {
  const t = W(e.editor), [n, i] = k(!1);
  return E(() => {
    i(!1);
  }, [t]), // Checks if only one block is selected.
  t.length === 1 && // Checks if the selected block is an image.
  t[0].type === "image" ? /* @__PURE__ */ o.jsxs(X, { withinPortal: !1, opened: n, position: "bottom", children: [
    /* @__PURE__ */ o.jsx(X.Target, { children: /* @__PURE__ */ o.jsx(
      _,
      {
        onClick: () => i(!n),
        isSelected: n,
        mainTooltip: "Replace Image",
        icon: Hr
      }
    ) }),
    /* @__PURE__ */ o.jsx(X.Dropdown, { children: /* @__PURE__ */ o.jsx($t, { editor: e.editor, block: t[0] }) })
  ] }) : null;
}, Ir = {
  bold: "Mod+B",
  italic: "Mod+I",
  underline: "Mod+U",
  strike: "Mod+Shift+X",
  code: ""
}, Or = {
  bold: br,
  italic: vr,
  underline: Sr,
  strike: yr,
  code: dr
}, me = (e) => {
  const t = W(e.editor), [n, i] = k(
    e.toggledStyle in e.editor.getActiveStyles()
  );
  U(e.editor, () => {
    i(e.toggledStyle in e.editor.getActiveStyles());
  });
  const a = (u) => {
    if (e.editor.focus(), e.editor.styleSchema[u].propSchema !== "boolean")
      throw new Error("can only toggle boolean styles");
    e.editor.toggleStyles({ [u]: !0 });
  };
  return L(() => !!t.find((u) => u.content !== void 0), [t]) ? /* @__PURE__ */ o.jsx(
    _,
    {
      onClick: () => a(e.toggledStyle),
      isSelected: n,
      mainTooltip: e.toggledStyle.slice(0, 1).toUpperCase() + e.toggledStyle.slice(1),
      secondaryTooltip: P(Ir[e.toggledStyle]),
      icon: Or[e.toggledStyle]
    }
  ) : null;
}, Ar = {
  left: gr,
  center: ur,
  right: hr,
  justify: fr
}, Ee = (e) => {
  const t = W(e.editor), n = L(() => {
    const s = t[0];
    if ("textAlignment" in s.props)
      return s.props.textAlignment;
  }, [t]), i = T(
    (s) => {
      e.editor.focus();
      for (const u of t)
        e.editor.updateBlock(u, {
          props: { textAlignment: s }
        });
    },
    [e.editor, t]
  );
  return L(() => !!t.find((s) => "textAlignment" in s.props), [t]) ? /* @__PURE__ */ o.jsx(
    _,
    {
      onClick: () => i(e.textAlignment),
      isSelected: n === e.textAlignment,
      mainTooltip: e.textAlignment === "justify" ? "Justify Text" : "Align Text " + e.textAlignment.slice(0, 1).toUpperCase() + e.textAlignment.slice(1),
      icon: Ar[e.textAlignment]
    }
  ) : null;
}, De = (e) => {
  const t = e.textColor || "default", n = e.backgroundColor || "default", i = e.size || 16, a = L(
    () => ({
      pointerEvents: "none",
      fontSize: (i * 0.75).toString() + "px",
      height: i.toString() + "px",
      lineHeight: i.toString() + "px",
      textAlign: "center",
      width: i.toString() + "px"
    }),
    [i]
  );
  return /* @__PURE__ */ o.jsx(
    Tt,
    {
      className: "bn-color-icon",
      "data-background-color": n,
      "data-text-color": t,
      style: a,
      children: "A"
    }
  );
}, Wt = (e) => {
  const t = () => e.text ? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(H.Label, { children: "Text" }),
    [
      "default",
      "gray",
      "brown",
      "red",
      "orange",
      "yellow",
      "green",
      "blue",
      "purple",
      "pink"
    ].map((i) => /* @__PURE__ */ o.jsx(
      H.Item,
      {
        onClick: () => {
          e.onClick && e.onClick(), e.text.setColor(i);
        },
        component: "div",
        "data-test": "text-color-" + i,
        leftSection: /* @__PURE__ */ o.jsx(De, { textColor: i, size: e.iconSize }),
        rightSection: e.text.color === i ? /* @__PURE__ */ o.jsx(Le, { size: 20, className: "bn-tick-icon" }) : /* @__PURE__ */ o.jsx("div", { className: "bn-tick-space" }),
        children: i.charAt(0).toUpperCase() + i.slice(1)
      },
      "text-color-" + i
    ))
  ] }) : null, n = () => e.background ? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(H.Label, { children: "Background" }),
    [
      "default",
      "gray",
      "brown",
      "red",
      "orange",
      "yellow",
      "green",
      "blue",
      "purple",
      "pink"
    ].map((i) => /* @__PURE__ */ o.jsx(
      H.Item,
      {
        onClick: () => {
          e.onClick && e.onClick(), e.background.setColor(i);
        },
        component: "div",
        "data-test": "background-color-" + i,
        leftSection: /* @__PURE__ */ o.jsx(De, { backgroundColor: i, size: e.iconSize }),
        rightSection: e.background.color === i ? /* @__PURE__ */ o.jsx(Le, { size: 20, className: "bn-tick-icon" }) : /* @__PURE__ */ o.jsx("div", { className: "bn-tick-space" }),
        children: i.charAt(0).toUpperCase() + i.slice(1)
      },
      "background-color-" + i
    ))
  ] }) : null;
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(t, {}),
    /* @__PURE__ */ o.jsx(n, {})
  ] });
}, Fr = (e) => {
  const t = W(e.editor), [n, i] = k(
    e.editor.getActiveStyles().textColor || "default"
  ), [a, s] = k(
    e.editor.getActiveStyles().backgroundColor || "default"
  );
  U(e.editor, () => {
    i(e.editor.getActiveStyles().textColor || "default"), s(
      e.editor.getActiveStyles().backgroundColor || "default"
    );
  });
  const { ref: u, updateMaxHeight: l } = Fe(), c = T(
    (m) => {
      e.editor.focus(), m === "default" ? e.editor.removeStyles({ textColor: m }) : e.editor.addStyles({ textColor: m });
    },
    [e.editor]
  ), g = T(
    (m) => {
      e.editor.focus(), m === "default" ? e.editor.removeStyles({ backgroundColor: m }) : e.editor.addStyles({ backgroundColor: m });
    },
    [e.editor]
  );
  return L(() => {
    for (const m of t)
      if (m.content !== void 0)
        return !0;
    return !1;
  }, [t]) ? /* @__PURE__ */ o.jsxs(H, { withinPortal: !1, onOpen: l, children: [
    /* @__PURE__ */ o.jsx(H.Target, { children: /* @__PURE__ */ o.jsx(
      _,
      {
        mainTooltip: "Colors",
        icon: () => /* @__PURE__ */ o.jsx(
          De,
          {
            textColor: n,
            backgroundColor: a,
            size: 20
          }
        )
      }
    ) }),
    /* @__PURE__ */ o.jsx("div", { ref: u, children: /* @__PURE__ */ o.jsx(H.Dropdown, { children: /* @__PURE__ */ o.jsx(
      Wt,
      {
        text: {
          color: n,
          setColor: c
        },
        background: {
          color: a,
          setColor: g
        }
      }
    ) }) })
  ] }) : null;
}, Nr = (e) => {
  const [t, n] = k(
    () => e.editor.canNestBlock()
  );
  U(e.editor, () => {
    e.editor.canNestBlock(), n(e.editor.canNestBlock());
  });
  const i = T(() => {
    e.editor.focus(), e.editor.nestBlock();
  }, [e.editor]);
  return /* @__PURE__ */ o.jsx(
    _,
    {
      onClick: i,
      isDisabled: !t,
      mainTooltip: "Nest Block",
      secondaryTooltip: P("Tab"),
      icon: xr
    }
  );
}, zr = (e) => {
  const [t, n] = k(
    () => e.editor.canUnnestBlock()
  );
  U(e.editor, () => {
    n(e.editor.canUnnestBlock());
  });
  const i = T(() => {
    e.editor.focus(), e.editor.unnestBlock();
  }, [e]);
  return /* @__PURE__ */ o.jsx(
    _,
    {
      onClick: i,
      isDisabled: !t,
      mainTooltip: "Unnest Block",
      secondaryTooltip: P("Shift+Tab"),
      icon: mr
    }
  );
}, Yt = le(({ url: e, text: t, update: n, ...i }, a) => {
  const [s, u] = k(e), [l, c] = k(t);
  E(() => {
    u(e), c(t);
  }, [t, e]);
  const g = T(
    (p) => {
      p.key === "Enter" && (p.preventDefault(), n(s, l));
    },
    [n, s, l]
  ), h = T(
    (p) => u(p.currentTarget.value),
    []
  ), m = T(
    (p) => c(p.currentTarget.value),
    []
  ), B = T(
    () => n(s, l),
    [n, s, l]
  );
  return /* @__PURE__ */ o.jsxs(Zt, { ...i, ref: a, children: [
    /* @__PURE__ */ o.jsx(
      Be,
      {
        type: "text",
        icon: Ft,
        inputProps: {
          autoFocus: !0,
          placeholder: "Edit URL",
          value: s,
          onKeyDown: g,
          onChange: h,
          onSubmit: B
        }
      }
    ),
    /* @__PURE__ */ o.jsx(
      Be,
      {
        type: "text",
        icon: ae,
        inputProps: {
          placeholder: "Edit Title",
          value: l,
          onKeyDown: g,
          onChange: m,
          onSubmit: B
        }
      }
    )
  ] });
}), Zr = (e) => {
  const t = W(e.editor), [n, i] = k(
    e.editor.getSelectedLinkUrl() || ""
  ), [a, s] = k(e.editor.getSelectedText());
  U(e.editor, () => {
    s(e.editor.getSelectedText() || ""), i(e.editor.getSelectedLinkUrl() || "");
  });
  const u = T(
    (c, g) => {
      e.editor.createLink(c, g), e.editor.focus();
    },
    [e.editor]
  );
  return L(() => {
    for (const c of t)
      if (c.content === void 0)
        return !1;
    return !0;
  }, [t]) ? /* @__PURE__ */ o.jsx(
    Ut,
    {
      target: /* @__PURE__ */ o.jsx(
        _,
        {
          mainTooltip: "Create Link",
          secondaryTooltip: P("Mod+K"),
          icon: Ft
        }
      ),
      dropdown: /* @__PURE__ */ o.jsx(Yt, { url: n, text: a, update: u })
    }
  ) : null;
}, Ur = (e) => /* @__PURE__ */ o.jsxs(Ae, { children: [
  /* @__PURE__ */ o.jsx(Lr, { ...e, items: e.blockTypeDropdownItems }),
  /* @__PURE__ */ o.jsx(_r, { editor: e.editor }),
  /* @__PURE__ */ o.jsx(Pr, { editor: e.editor }),
  /* @__PURE__ */ o.jsx(me, { editor: e.editor, toggledStyle: "bold" }),
  /* @__PURE__ */ o.jsx(me, { editor: e.editor, toggledStyle: "italic" }),
  /* @__PURE__ */ o.jsx(me, { editor: e.editor, toggledStyle: "underline" }),
  /* @__PURE__ */ o.jsx(me, { editor: e.editor, toggledStyle: "strike" }),
  /* @__PURE__ */ o.jsx(Ee, { editor: e.editor, textAlignment: "left" }),
  /* @__PURE__ */ o.jsx(Ee, { editor: e.editor, textAlignment: "center" }),
  /* @__PURE__ */ o.jsx(Ee, { editor: e.editor, textAlignment: "right" }),
  /* @__PURE__ */ o.jsx(Fr, { editor: e.editor }),
  /* @__PURE__ */ o.jsx(Nr, { editor: e.editor }),
  /* @__PURE__ */ o.jsx(zr, { editor: e.editor }),
  /* @__PURE__ */ o.jsx(Zr, { editor: e.editor })
] }), bt = (e) => {
  switch (e) {
    case "left":
      return "top-start";
    case "center":
      return "top";
    case "right":
      return "top-end";
    default:
      return "top-start";
  }
}, $r = (e) => {
  const [t, n] = k(
    () => {
      const c = e.editor.getTextCursorPosition().block;
      return "textAlignment" in c.props ? bt(
        c.props.textAlignment
      ) : "top-start";
    }
  );
  U(e.editor, () => {
    const c = e.editor.getTextCursorPosition().block;
    "textAlignment" in c.props ? n(
      bt(
        c.props.textAlignment
      )
    ) : n("top-start");
  });
  const i = ee(
    e.editor.formattingToolbar.onUpdate.bind(e.editor.formattingToolbar)
  ), { isMounted: a, ref: s, style: u } = de(
    (i == null ? void 0 : i.show) || !1,
    (i == null ? void 0 : i.referencePos) || null,
    3e3,
    {
      placement: t,
      middleware: [se(10), ke()]
    }
  );
  if (!a || !i)
    return null;
  const l = e.formattingToolbar || Ur;
  return /* @__PURE__ */ o.jsx("div", { ref: s, style: u, children: /* @__PURE__ */ o.jsx(l, { editor: e.editor }) });
}, Wr = (e) => {
  const [t, n] = k(!1), i = Z(null), {
    text: a,
    url: s,
    deleteHyperlink: u,
    editHyperlink: l,
    startHideTimer: c,
    stopHideTimer: g
  } = e;
  return t ? /* @__PURE__ */ o.jsx(
    Yt,
    {
      url: s,
      text: a,
      update: l,
      onBlur: (h) => setTimeout(() => {
        var m;
        (m = i.current) != null && m.contains(h.relatedTarget) || n(!1);
      }, 500),
      ref: i
    }
  ) : /* @__PURE__ */ o.jsxs(Ae, { onMouseEnter: g, onMouseLeave: c, children: [
    /* @__PURE__ */ o.jsx(
      _,
      {
        mainTooltip: "Edit",
        isSelected: !1,
        onClick: () => n(!0),
        children: "Edit Link"
      }
    ),
    /* @__PURE__ */ o.jsx(
      _,
      {
        mainTooltip: "Open in new tab",
        isSelected: !1,
        onClick: () => {
          window.open(s, "_blank");
        },
        icon: wr
      }
    ),
    /* @__PURE__ */ o.jsx(
      _,
      {
        mainTooltip: "Remove link",
        isSelected: !1,
        onClick: u,
        icon: kr
      }
    )
  ] });
}, Yr = (e) => {
  const t = {
    deleteHyperlink: e.editor.hyperlinkToolbar.deleteHyperlink,
    editHyperlink: e.editor.hyperlinkToolbar.editHyperlink,
    startHideTimer: e.editor.hyperlinkToolbar.startHideTimer,
    stopHideTimer: e.editor.hyperlinkToolbar.stopHideTimer
  }, n = ee(
    e.editor.hyperlinkToolbar.onUpdate.bind(e.editor.hyperlinkToolbar)
  ), { isMounted: i, ref: a, style: s } = de(
    (n == null ? void 0 : n.show) || !1,
    (n == null ? void 0 : n.referencePos) || null,
    4e3,
    {
      placement: "top-start",
      middleware: [se(10), ke()]
    }
  );
  if (!i || !n)
    return null;
  const { show: u, referencePos: l, ...c } = n, g = e.hyperlinkToolbar || Wr;
  return /* @__PURE__ */ o.jsx("div", { ref: a, style: s, children: /* @__PURE__ */ o.jsx(g, { ...c, ...t }) });
}, Kr = (e) => {
  const t = ee(
    e.editor.imageToolbar.onUpdate.bind(e.editor.imageToolbar)
  ), { isMounted: n, ref: i, style: a } = de(
    (t == null ? void 0 : t.show) || !1,
    (t == null ? void 0 : t.referencePos) || null,
    5e3,
    {
      placement: "bottom",
      middleware: [se(10), ke()]
    }
  );
  if (!n || !t)
    return null;
  const { show: s, referencePos: u, ...l } = t, c = e.imageToolbar || $t;
  return /* @__PURE__ */ o.jsx("div", { ref: i, style: a, children: /* @__PURE__ */ o.jsx(c, { editor: e.editor, ...l }) });
};
function qr(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z" } }, { tag: "path", attr: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z" } }] })(e);
}
const Kt = (e) => /* @__PURE__ */ o.jsx(jt, { size: 24, children: e.children }), Gr = (e) => /* @__PURE__ */ o.jsx(Kt, { children: /* @__PURE__ */ o.jsx(
  qr,
  {
    size: 24,
    onClick: e.addBlock,
    "data-test": "dragHandleAdd"
  }
) });
function qt(e) {
  return S({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" } }] })(e);
}
const Gt = (e) => {
  const { children: t, ...n } = e;
  return /* @__PURE__ */ o.jsx(H.Item, { ...n, children: t });
}, Jr = (e) => {
  const [t, n] = k(!1), { ref: i, updateMaxHeight: a } = Fe(), s = Z(), u = T(() => {
    s.current && clearTimeout(s.current), s.current = setTimeout(() => {
      n(!1);
    }, 250);
  }, []), l = T(() => {
    s.current && clearTimeout(s.current), t || a(), n(!0);
  }, [t, a]);
  return !("textColor" in e.block.props) && !("backgroundColor" in e.block.props) ? null : /* @__PURE__ */ o.jsx(
    Gt,
    {
      onMouseLeave: u,
      onMouseOver: l,
      children: /* @__PURE__ */ o.jsxs(H, { withinPortal: !1, opened: t, position: "right", children: [
        /* @__PURE__ */ o.jsx(H.Target, { children: /* @__PURE__ */ o.jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
          /* @__PURE__ */ o.jsx("div", { style: { flex: 1 }, children: e.children }),
          /* @__PURE__ */ o.jsx(Tt, { style: { display: "flex", alignItems: "center" }, children: /* @__PURE__ */ o.jsx(Mr, { size: 15 }) })
        ] }) }),
        /* @__PURE__ */ o.jsx("div", { ref: i, children: /* @__PURE__ */ o.jsx(
          H.Dropdown,
          {
            onMouseLeave: u,
            onMouseOver: l,
            style: { marginLeft: "5px" },
            children: /* @__PURE__ */ o.jsx(
              Wt,
              {
                iconSize: 18,
                text: "textColor" in e.block.props && typeof e.block.props.textColor == "string" ? {
                  color: e.block.props.textColor,
                  setColor: (c) => e.editor.updateBlock(e.block, {
                    props: { textColor: c }
                  })
                } : void 0,
                background: "backgroundColor" in e.block.props && typeof e.block.props.backgroundColor == "string" ? {
                  color: e.block.props.backgroundColor,
                  setColor: (c) => e.editor.updateBlock(e.block, {
                    props: { backgroundColor: c }
                  })
                } : void 0
              }
            )
          }
        ) })
      ] })
    }
  );
}, Qr = (e) => /* @__PURE__ */ o.jsx(
  Gt,
  {
    onClick: () => e.editor.removeBlocks([e.block]),
    children: e.children
  }
), Xr = (e) => /* @__PURE__ */ o.jsx(H.Dropdown, { className: "bn-drag-handle-menu", children: e.children }), eo = (e) => /* @__PURE__ */ o.jsxs(Xr, { children: [
  /* @__PURE__ */ o.jsx(Qr, { ...e, children: "Delete" }),
  /* @__PURE__ */ o.jsx(Jr, { ...e, children: "Colors" })
] }), to = (e) => {
  const t = e.dragHandleMenu || eo;
  return /* @__PURE__ */ o.jsxs(
    H,
    {
      withinPortal: !1,
      trigger: "click",
      onOpen: e.freezeMenu,
      onClose: e.unfreezeMenu,
      width: 100,
      position: "left",
      children: [
        /* @__PURE__ */ o.jsx(H.Target, { children: /* @__PURE__ */ o.jsx(
          "div",
          {
            className: "bn-drag-handle",
            draggable: "true",
            onDragStart: e.blockDragStart,
            onDragEnd: e.blockDragEnd,
            children: /* @__PURE__ */ o.jsx(Kt, { children: /* @__PURE__ */ o.jsx(qt, { size: 24, "data-test": "dragHandle" }) })
          }
        ) }),
        /* @__PURE__ */ o.jsx(t, { editor: e.editor, block: e.block })
      ]
    }
  );
}, no = (e) => /* @__PURE__ */ o.jsx(Pe, { className: "bn-side-menu", gap: 0, children: e.children }), ro = (e) => {
  const { addBlock: t, ...n } = e;
  return /* @__PURE__ */ o.jsxs(no, { children: [
    /* @__PURE__ */ o.jsx(Gr, { addBlock: t }),
    /* @__PURE__ */ o.jsx(to, { ...n })
  ] });
}, oo = (e) => {
  const t = {
    addBlock: e.editor.sideMenu.addBlock,
    blockDragStart: e.editor.sideMenu.blockDragStart,
    blockDragEnd: e.editor.sideMenu.blockDragEnd,
    freezeMenu: e.editor.sideMenu.freezeMenu,
    unfreezeMenu: e.editor.sideMenu.unfreezeMenu
  }, n = ee(
    e.editor.sideMenu.onUpdate.bind(e.editor.sideMenu)
  ), { isMounted: i, ref: a, style: s } = de(
    (n == null ? void 0 : n.show) || !1,
    (n == null ? void 0 : n.referencePos) || null,
    1e3,
    {
      placement: "left"
    }
  );
  if (!i || !n)
    return null;
  const { show: u, referencePos: l, ...c } = n, g = e.sideMenu || ro;
  return /* @__PURE__ */ o.jsx("div", { ref: a, style: s, children: /* @__PURE__ */ o.jsx(g, { editor: e.editor, ...c, ...t }) });
};
function io(e, t, n, i = 3) {
  const a = Z(0);
  E(() => {
    t !== void 0 && (e.length > 0 ? a.current = t.length : t.length - a.current > i && n());
  }, [n, i, e.length, t]);
}
function ao(e, t) {
  const [n, i] = k([]), [a, s] = k(!1), u = Z(), l = Z();
  return E(() => {
    const c = e;
    u.current = e, s(!0), t(e).then((g) => {
      u.current === c && (i(g), s(!1), l.current = c);
    });
  }, [e, t]), {
    items: n || [],
    // The query that was used to retrieve the last set of items may not be the
    // same as the current query as the items from the current query may not
    // have been retrieved yet. This is useful when using the returns of this
    // hook in other hooks.
    usedQuery: l.current,
    loadingState: l.current === void 0 ? "loading-initial" : a ? "loading" : "loaded"
  };
}
function lo(e, t, n, i) {
  const [a, s] = k(0);
  return E(() => {
    const u = (l) => l.key === "ArrowUp" ? (l.preventDefault(), t.length && s((a - 1 + t.length) % t.length), !0) : l.key === "ArrowDown" ? (l.preventDefault(), t.length && s((a + 1) % t.length), !0) : l.key === "Enter" ? (l.preventDefault(), t.length && (i == null || i(t[a])), !0) : l.key === "Escape" ? (l.preventDefault(), n(), !0) : !1;
    return e.domElement.addEventListener(
      "keydown",
      u,
      !0
    ), () => {
      e.domElement.removeEventListener(
        "keydown",
        u,
        !0
      );
    };
  }, [n, e.domElement, t, a, i]), a;
}
function so(e) {
  const {
    editor: t,
    getItems: n,
    suggestionMenuComponent: i,
    query: a,
    closeMenu: s,
    onItemClick: u
  } = e, { items: l, usedQuery: c, loadingState: g } = ao(
    a,
    n
  );
  io(l, c, s);
  const h = lo(
    t,
    l,
    s,
    u
  ), m = i;
  return /* @__PURE__ */ o.jsx(
    m,
    {
      items: l,
      onItemClick: u,
      loadingState: g,
      selectedIndex: h
    }
  );
}
const co = 5;
function uo(e) {
  const t = Z(null);
  function n() {
    var u;
    const a = e.isSelected, s = (u = t.current) == null ? void 0 : u.matches(":hover");
    return a || s;
  }
  function i() {
    var a, s;
    n() ? (a = t.current) == null || a.setAttribute("data-hovered", "true") : (s = t.current) == null || s.removeAttribute("data-hovered");
  }
  return E(() => {
    i(), n() && t.current && t.current.getBoundingClientRect().left > co && t.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    });
  }), /* @__PURE__ */ o.jsx(
    H.Item,
    {
      className: "bn-slash-menu-item",
      onClick: e.onClick,
      closeMenuOnClick: !1,
      onMouseLeave: () => {
        setTimeout(() => {
          i();
        }, 1);
      },
      leftSection: e.icon,
      rightSection: e.badge && /* @__PURE__ */ o.jsx(In, { size: "xs", children: e.badge }),
      ref: t,
      children: /* @__PURE__ */ o.jsxs(Oe, { children: [
        /* @__PURE__ */ o.jsx(ie, { lh: "20px", size: "14px", fw: 500, children: e.title }),
        /* @__PURE__ */ o.jsx(ie, { lh: "16px", size: "10px", children: e.subtext })
      ] })
    }
  );
}
function fo(e) {
  const { items: t, loadingState: n, selectedIndex: i, onItemClick: a } = e, s = n === "loading-initial" || n === "loading" ? /* @__PURE__ */ o.jsx(On, { className: "bn-slash-menu-loader", type: "dots" }) : null, u = L(() => {
    let l;
    const c = [];
    for (let g = 0; g < t.length; g++) {
      const h = t[g];
      h.group !== l && (l = h.group, c.push(
        /* @__PURE__ */ o.jsx(H.Label, { children: l }, l)
      )), c.push(
        /* @__PURE__ */ Ln(
          uo,
          {
            ...h,
            isSelected: g === i,
            key: h.title,
            onClick: () => a == null ? void 0 : a(h)
          }
        )
      );
    }
    return c;
  }, [t, i, a]);
  return /* @__PURE__ */ o.jsx(
    H,
    {
      withinPortal: !1,
      trapFocus: !1,
      defaultOpened: !0,
      trigger: "hover",
      closeDelay: 1e7,
      children: /* @__PURE__ */ o.jsxs(
        H.Dropdown,
        {
          onMouseDown: (l) => l.preventDefault(),
          className: "bn-slash-menu",
          children: [
            u,
            Bn.count(u) === 0 && (e.loadingState === "loading" || e.loadingState === "loaded") && /* @__PURE__ */ o.jsx(H.Item, { children: "No match found" }),
            s
          ]
        }
      )
    }
  );
}
function go(e) {
  const {
    editor: t,
    triggerCharacter: n,
    onItemClick: i,
    getItems: a,
    suggestionMenuComponent: s
  } = e, u = {
    closeMenu: t.suggestionMenus.closeMenu,
    clearQuery: t.suggestionMenus.clearQuery
  }, l = ee(
    (I) => e.editor.suggestionMenus.onUpdate.bind(t.suggestionMenus)(
      n || "/",
      I
    )
  ), { isMounted: c, ref: g, style: h } = de(
    (l == null ? void 0 : l.show) || !1,
    (l == null ? void 0 : l.referencePos) || null,
    2e3,
    {
      placement: "bottom-start",
      middleware: [
        se(10),
        // Flips the menu placement to maximize the space available, and prevents
        // the menu from being cut off by the confines of the screen.
        ke(),
        Dn({
          apply({ availableHeight: I, elements: K }) {
            Object.assign(K.floating.style, {
              maxHeight: `${I - 10}px`
            });
          }
        })
      ]
    }
  ), m = T(
    (I) => {
      t.suggestionMenus.closeMenu(), t.suggestionMenus.clearQuery(), i == null || i(I);
    },
    [i, t.suggestionMenus]
  );
  if (!c || !l)
    return null;
  const { show: B, referencePos: p, ...Y } = l;
  return /* @__PURE__ */ o.jsx("div", { ref: g, style: h, children: /* @__PURE__ */ o.jsx(
    so,
    {
      editor: t,
      getItems: a,
      suggestionMenuComponent: s || fo,
      onItemClick: m,
      ...Y,
      ...u
    }
  ) });
}
function ho(e) {
  let t = e.getTextCursorPosition().block, n = e.blockSchema[t.type].content;
  for (; n === "none"; )
    t = e.getTextCursorPosition().nextBlock, n = e.blockSchema[t.type].content, e.setTextCursorPosition(t, "end");
}
function N(e, t) {
  const n = e.getTextCursorPosition().block;
  if (n.content === void 0)
    throw new Error("Slash Menu open in a block that doesn't contain content.");
  Array.isArray(n.content) && (n.content.length === 1 && Fn(n.content[0]) && n.content[0].type === "text" && n.content[0].text === "/" || n.content.length === 0) ? e.updateBlock(n, t) : (e.insertBlocks([t], n, "after"), e.setTextCursorPosition(
    e.getTextCursorPosition().nextBlock,
    "end"
  ));
  const i = e.getTextCursorPosition().block;
  return ho(e), i;
}
function bo() {
  return [
    {
      title: "Heading 1",
      // Unfortunately, we can't use a more specific BlockNoteEditor type here,
      // Typescript seems to get in the way there
      // This means that we don't have type checking for calling insertOrUpdateBlock etc. :(
      onItemClick: (t) => {
        N(t, {
          type: "heading",
          props: { level: 1 }
        });
      },
      subtext: "Used for a top-level heading",
      icon: /* @__PURE__ */ o.jsx(It, { size: 18 }),
      badge: P("Mod-Alt-1"),
      aliases: ["h", "heading1", "h1"],
      group: "Headings"
    },
    {
      title: "Heading 2",
      onItemClick: (t) => {
        N(t, {
          type: "heading",
          props: { level: 2 }
        });
      },
      subtext: "Used for key sections",
      icon: /* @__PURE__ */ o.jsx(Ot, { size: 18 }),
      badge: P("Mod-Alt-2"),
      aliases: ["h2", "heading2", "subheading"],
      group: "Headings"
    },
    {
      title: "Heading 3",
      onItemClick: (t) => {
        N(t, {
          type: "heading",
          props: { level: 3 }
        });
      },
      subtext: "Used for subsections and group headings",
      icon: /* @__PURE__ */ o.jsx(At, { size: 18 }),
      badge: P("Mod-Alt-3"),
      aliases: ["h3", "heading3", "subheading"],
      group: "Headings"
    },
    {
      title: "Numbered List",
      onItemClick: (t) => {
        N(t, {
          type: "numberedListItem"
        });
      },
      subtext: "Used to display a numbered list",
      icon: /* @__PURE__ */ o.jsx(Nt, { size: 18 }),
      badge: P("Mod-Shift-7"),
      aliases: ["ol", "li", "list", "numberedlist", "numbered list"],
      group: "Basic blocks"
    },
    {
      title: "Bullet List",
      onItemClick: (t) => {
        N(t, {
          type: "bulletListItem"
        });
      },
      subtext: "Used to display an unordered list",
      icon: /* @__PURE__ */ o.jsx(zt, { size: 18 }),
      badge: P("Mod-Shift-8"),
      aliases: ["ul", "li", "list", "bulletlist", "bullet list"],
      group: "Basic blocks"
    },
    {
      title: "Paragraph",
      onItemClick: (t) => {
        N(t, {
          type: "paragraph"
        });
      },
      subtext: "Used for the body of your document",
      icon: /* @__PURE__ */ o.jsx(ae, { size: 18 }),
      badge: P("Mod-Alt-0"),
      aliases: ["p", "paragraph"],
      group: "Basic blocks"
    },
    {
      title: "Table",
      onItemClick: (t) => {
        N(t, {
          type: "table",
          content: {
            type: "tableContent",
            rows: [
              {
                cells: ["", "", ""]
              },
              {
                cells: ["", "", ""]
              }
            ]
          }
        });
      },
      subtext: "Used for for tables",
      icon: /* @__PURE__ */ o.jsx(Cr, { size: 18 }),
      aliases: ["table"],
      group: "Advanced",
      badge: void 0
    },
    {
      title: "Image",
      onItemClick: (t) => {
        const n = N(t, {
          type: "image"
        });
        t._tiptapEditor.view.dispatch(
          t._tiptapEditor.state.tr.setMeta(Nn, {
            block: n
          })
        );
      },
      subtext: "Insert an image",
      icon: /* @__PURE__ */ o.jsx(jr, {}),
      aliases: [
        "image",
        "imageUpload",
        "upload",
        "img",
        "picture",
        "media",
        "url",
        "drive",
        "dropbox"
      ],
      group: "Media"
    }
  ];
}
function mo(e, t) {
  return e.filter(
    ({ title: n, aliases: i }) => n.toLowerCase().startsWith(t.toLowerCase()) || i && i.filter(
      (a) => a.toLowerCase().startsWith(t.toLowerCase())
    ).length !== 0
  );
}
function xo(e, t, n) {
  return n && n.draggedCellOrientation === "row" ? new DOMRect(
    t.x,
    n.mousePos,
    t.width,
    0
  ) : new DOMRect(
    t.x,
    e.y,
    t.width,
    e.height
  );
}
function vo(e, t, n) {
  return n && n.draggedCellOrientation === "col" ? new DOMRect(
    n.mousePos,
    t.y,
    0,
    t.height
  ) : new DOMRect(
    e.x,
    t.y,
    e.width,
    t.height
  );
}
function mt(e, t, n, i, a) {
  const [, s] = k(0), { refs: u, update: l, context: c, floatingStyles: g } = Ct({
    open: t,
    placement: e === "row" ? "left" : "top",
    middleware: [se(e === "row" ? -10 : -12)]
  }), { isMounted: h, styles: m } = St(c);
  return E(() => {
    s(Math.random()), l();
  }, [n, i, l]), E(() => {
    n === null || i === null || u.setReference({
      getBoundingClientRect: () => (e === "row" ? xo : vo)(n, i, a)
    });
  }, [a, e, n, i, u]), L(
    () => ({
      isMounted: h,
      ref: u.setFloating,
      style: {
        display: "flex",
        ...m,
        ...g,
        zIndex: 1e4
      }
    }),
    [g, h, u.setFloating, m]
  );
}
function ko(e, t, n, i) {
  const a = mt(
    "row",
    e,
    t,
    n,
    i
  ), s = mt(
    "col",
    e,
    t,
    n,
    i
  );
  return L(
    () => ({
      rowHandle: a,
      colHandle: s
    }),
    [s, a]
  );
}
const yo = (e) => /* @__PURE__ */ o.jsx(H.Dropdown, { className: "bn-table-handle-menu", children: e.children }), ye = (e) => {
  const { children: t, ...n } = e;
  return /* @__PURE__ */ o.jsx(H.Item, { ...n, children: t });
}, Co = (e) => /* @__PURE__ */ o.jsx(
  ye,
  {
    onClick: () => {
      const t = e.block.content.rows[e.index].cells.map(
        () => []
      ), n = [...e.block.content.rows];
      n.splice(e.index + (e.side === "below" ? 1 : 0), 0, {
        cells: t
      }), e.editor.updateBlock(e.block, {
        type: "table",
        content: {
          type: "tableContent",
          rows: n
        }
      });
    },
    children: `Add row ${e.side}`
  }
), So = (e) => /* @__PURE__ */ o.jsx(
  ye,
  {
    onClick: () => {
      const t = {
        type: "tableContent",
        rows: e.block.content.rows.map((n) => {
          const i = [...n.cells];
          return i.splice(e.index + (e.side === "right" ? 1 : 0), 0, []), { cells: i };
        })
      };
      e.editor.updateBlock(e.block, {
        type: "table",
        content: t
      });
    },
    children: `Add column ${e.side}`
  }
), xt = (e) => e.orientation === "row" ? /* @__PURE__ */ o.jsx(Co, { ...e, side: e.side }) : /* @__PURE__ */ o.jsx(So, { ...e, side: e.side }), jo = (e) => /* @__PURE__ */ o.jsx(
  ye,
  {
    onClick: () => {
      const t = {
        type: "tableContent",
        rows: e.block.content.rows.filter(
          (n, i) => i !== e.index
        )
      };
      e.editor.updateBlock(e.block, {
        type: "table",
        content: t
      });
    },
    children: "Delete row"
  }
), Ho = (e) => /* @__PURE__ */ o.jsx(
  ye,
  {
    onClick: () => {
      const t = {
        type: "tableContent",
        rows: e.block.content.rows.map((n) => ({
          cells: n.cells.filter((i, a) => a !== e.index)
        }))
      };
      e.editor.updateBlock(e.block, {
        type: "table",
        content: t
      });
    },
    children: "Delete column"
  }
), wo = (e) => e.orientation === "row" ? /* @__PURE__ */ o.jsx(jo, { ...e }) : /* @__PURE__ */ o.jsx(Ho, { ...e }), To = (e) => /* @__PURE__ */ o.jsxs(yo, { children: [
  /* @__PURE__ */ o.jsx(
    wo,
    {
      orientation: e.orientation,
      editor: e.editor,
      block: e.block,
      index: e.index
    }
  ),
  /* @__PURE__ */ o.jsx(
    xt,
    {
      orientation: e.orientation,
      editor: e.editor,
      block: e.block,
      index: e.index,
      side: e.orientation === "row" ? "above" : "left"
    }
  ),
  /* @__PURE__ */ o.jsx(
    xt,
    {
      orientation: e.orientation,
      editor: e.editor,
      block: e.block,
      index: e.index,
      side: e.orientation === "row" ? "below" : "right"
    }
  )
] }), po = (e) => {
  const t = e.tableHandleMenu || To, [n, i] = k(!1);
  return /* @__PURE__ */ o.jsxs(
    H,
    {
      withinPortal: !1,
      trigger: "click",
      onOpen: () => {
        e.freezeHandles(), e.hideOtherSide();
      },
      onClose: () => {
        e.unfreezeHandles(), e.showOtherSide();
      },
      position: "right",
      children: [
        /* @__PURE__ */ o.jsx(H.Target, { children: /* @__PURE__ */ o.jsx(
          "div",
          {
            className: ce(
              "bn-table-handle",
              n ? "bn-table-handle-dragging" : ""
            ),
            draggable: "true",
            onDragStart: (a) => {
              i(!0), e.dragStart(a);
            },
            onDragEnd: () => {
              e.dragEnd(), i(!1);
            },
            style: e.orientation === "column" ? { transform: "rotate(0.25turn)" } : void 0,
            children: e.children
          }
        ) }),
        /* @__PURE__ */ o.jsx(
          t,
          {
            orientation: e.orientation,
            editor: e.editor,
            block: e.block,
            index: e.index
          }
        )
      ]
    }
  );
}, Mo = (e) => /* @__PURE__ */ o.jsx(po, { ...e, children: /* @__PURE__ */ o.jsx(qt, { size: 24, "data-test": "tableHandle" }) }), Eo = (e) => {
  var h, m;
  const t = {
    rowDragStart: e.editor.tableHandles.rowDragStart,
    colDragStart: e.editor.tableHandles.colDragStart,
    dragEnd: e.editor.tableHandles.dragEnd,
    freezeHandles: e.editor.tableHandles.freezeHandles,
    unfreezeHandles: e.editor.tableHandles.unfreezeHandles
  }, n = ee(
    e.editor.tableHandles.onUpdate.bind(e.editor.tableHandles)
  ), { rowHandle: i, colHandle: a } = ko(
    (n == null ? void 0 : n.show) || !1,
    (n == null ? void 0 : n.referencePosCell) || null,
    (n == null ? void 0 : n.referencePosTable) || null,
    n != null && n.draggingState ? {
      draggedCellOrientation: (h = n == null ? void 0 : n.draggingState) == null ? void 0 : h.draggedCellOrientation,
      mousePos: (m = n == null ? void 0 : n.draggingState) == null ? void 0 : m.mousePos
    } : void 0
  );
  console.log(n), console.log(i), console.log(a);
  const [s, u] = k(!1), [l, c] = k(!1);
  if (!i.isMounted || !a.isMounted || !n)
    return null;
  const g = e.tableHandle || Mo;
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    !s && /* @__PURE__ */ o.jsx("div", { ref: i.ref, style: i.style, children: /* @__PURE__ */ o.jsx(
      g,
      {
        editor: e.editor,
        orientation: "row",
        showOtherSide: () => c(!1),
        hideOtherSide: () => c(!0),
        index: n.rowIndex,
        block: n.block,
        dragStart: t.rowDragStart,
        dragEnd: t.dragEnd,
        freezeHandles: t.freezeHandles,
        unfreezeHandles: t.unfreezeHandles
      }
    ) }),
    !l && /* @__PURE__ */ o.jsx("div", { ref: a.ref, style: a.style, children: /* @__PURE__ */ o.jsx(
      g,
      {
        editor: e.editor,
        orientation: "column",
        showOtherSide: () => u(!1),
        hideOtherSide: () => u(!0),
        index: n.colIndex,
        block: n.block,
        dragStart: t.colDragStart,
        dragEnd: t.dragEnd,
        freezeHandles: t.freezeHandles,
        unfreezeHandles: t.unfreezeHandles
      }
    ) })
  ] });
};
function Ro(e) {
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    e.formattingToolbar !== !1 && /* @__PURE__ */ o.jsx($r, { editor: e.editor }),
    e.hyperlinkToolbar !== !1 && /* @__PURE__ */ o.jsx(Yr, { editor: e.editor }),
    e.slashMenu !== !1 && /* @__PURE__ */ o.jsx(
      go,
      {
        editor: e.editor,
        getItems: async (t) => mo(bo(), t),
        onItemClick: (t) => {
          t.onItemClick(e.editor);
        }
      }
    ),
    e.sideMenu !== !1 && /* @__PURE__ */ o.jsx(oo, { editor: e.editor }),
    e.imageToolbar !== !1 && /* @__PURE__ */ o.jsx(Kr, { editor: e.editor }),
    e.editor.blockSchema.table && e.tableHandles !== !1 && /* @__PURE__ */ o.jsx(Eo, { editor: e.editor })
  ] });
}
const Jt = (e, t, n = !1) => {
  const i = [];
  function a(s, u = "--bn") {
    for (const l in s) {
      const c = l.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), g = `${u}-${c}`;
      typeof s[l] != "object" ? (typeof s[l] == "number" && (s[l] = `${s[l]}px`), n ? t.style.removeProperty(g) : t.style.setProperty(g, s[l].toString())) : a(s[l], g);
    }
  }
  return a(e), i;
}, vt = (e, t) => Jt(e, t), Vo = {
  colors: {
    editor: {
      text: void 0,
      background: void 0
    },
    menu: {
      text: void 0,
      background: void 0
    },
    tooltip: {
      text: void 0,
      background: void 0
    },
    hovered: {
      text: void 0,
      background: void 0
    },
    selected: {
      text: void 0,
      background: void 0
    },
    disabled: {
      text: void 0,
      background: void 0
    },
    shadow: void 0,
    border: void 0,
    sideMenu: void 0,
    highlights: {
      gray: {
        text: void 0,
        background: void 0
      },
      brown: {
        text: void 0,
        background: void 0
      },
      red: {
        text: void 0,
        background: void 0
      },
      orange: {
        text: void 0,
        background: void 0
      },
      yellow: {
        text: void 0,
        background: void 0
      },
      green: {
        text: void 0,
        background: void 0
      },
      blue: {
        text: void 0,
        background: void 0
      },
      purple: {
        text: void 0,
        background: void 0
      },
      pink: {
        text: void 0,
        background: void 0
      }
    }
  },
  borderRadius: void 0,
  fontFamily: void 0
}, Lo = (e) => Jt(Vo, e, !0);
const Bo = {
  // Removes button press effect
  activeClassName: ""
};
function Uo(e) {
  const { editor: t, className: n, theme: i, children: a, ...s } = e, u = rr(), [l, c] = k(void 0);
  return E(() => {
    if (Lo(t.domElement.parentElement), i === "light") {
      c("light");
      return;
    }
    if (i === "dark") {
      c("dark");
      return;
    }
    if (typeof i == "object") {
      if ("light" in i && "dark" in i) {
        vt(
          i[u === "dark" ? "dark" : "light"],
          t.domElement.parentElement
        ), c(u === "dark" ? "dark" : "light");
        return;
      }
      vt(
        i,
        t.domElement.parentElement
      ), c(void 0);
      return;
    }
    c(u === "dark" ? "dark" : "light");
  }, [u, t.domElement, i]), // `cssVariablesSelector` scopes Mantine CSS variables to only the editor,
  // as proposed here:  https://github.com/orgs/mantinedev/discussions/5685
  /* @__PURE__ */ o.jsx(An, { theme: Bo, cssVariablesSelector: ".bn-container", children: /* @__PURE__ */ o.jsx(
    tr,
    {
      editor: t._tiptapEditor,
      className: ce("bn-container", n || ""),
      "data-color-scheme": l,
      ...s,
      children: a || /* @__PURE__ */ o.jsx(Ro, { editor: t })
    }
  ) });
}
const C = [
  "#FFFFFF",
  "#EFEFEF",
  "#CFCFCF",
  "#AFAFAF",
  "#7F7F7F",
  "#3F3F3F",
  "#1F1F1F",
  "#161616",
  "#0F0F0F",
  "#000000"
], kt = {
  colors: {
    editor: {
      text: C[5],
      background: C[0]
    },
    menu: {
      text: C[5],
      background: C[0]
    },
    tooltip: {
      text: C[5],
      background: C[1]
    },
    hovered: {
      text: C[5],
      background: C[1]
    },
    selected: {
      text: C[0],
      background: C[5]
    },
    disabled: {
      text: C[3],
      background: C[1]
    },
    shadow: C[2],
    border: C[1],
    sideMenu: C[2],
    highlights: {
      gray: {
        text: "#9b9a97",
        background: "#ebeced"
      },
      brown: {
        text: "#64473a",
        background: "#e9e5e3"
      },
      red: {
        text: "#e03e3e",
        background: "#fbe4e4"
      },
      orange: {
        text: "#d9730d",
        background: "#f6e9d9"
      },
      yellow: {
        text: "#dfab01",
        background: "#fbf3db"
      },
      green: {
        text: "#4d6461",
        background: "#ddedea"
      },
      blue: {
        text: "#0b6e99",
        background: "#ddebf1"
      },
      purple: {
        text: "#6940a5",
        background: "#eae4f2"
      },
      pink: {
        text: "#ad1a72",
        background: "#f4dfeb"
      }
    }
  },
  borderRadius: 6,
  fontFamily: '"Inter", "SF Pro Display", -apple-system, BlinkMacSystemFont, "Open Sans", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
}, $o = {
  colors: {
    editor: {
      text: C[2],
      background: C[6]
    },
    menu: {
      text: C[2],
      background: C[6]
    },
    tooltip: {
      text: C[2],
      background: C[7]
    },
    hovered: {
      text: C[2],
      background: C[7]
    },
    selected: {
      text: C[2],
      background: C[8]
    },
    disabled: {
      text: C[5],
      background: C[7]
    },
    shadow: C[8],
    border: C[7],
    sideMenu: C[4],
    highlights: {
      gray: {
        text: "#bebdb8",
        background: "#9b9a97"
      },
      brown: {
        text: "#8e6552",
        background: "#64473a"
      },
      red: {
        text: "#ec4040",
        background: "#be3434"
      },
      orange: {
        text: "#e3790d",
        background: "#b7600a"
      },
      yellow: {
        text: "#dfab01",
        background: "#b58b00"
      },
      green: {
        text: "#6b8b87",
        background: "#4d6461"
      },
      blue: {
        text: "#0e87bc",
        background: "#0b6e99"
      },
      purple: {
        text: "#8552d7",
        background: "#6940a5"
      },
      pink: {
        text: "#da208f",
        background: "#ad1a72"
      }
    }
  },
  borderRadius: kt.borderRadius,
  fontFamily: kt.fontFamily
};
function Wo(e) {
  const [t, n] = k(() => e.getActiveStyles());
  return Bt(e, () => {
    n(e.getActiveStyles());
  }), Dt(e, () => {
    n(e.getActiveStyles());
  }), t;
}
const Do = (e) => zn.create(e), Yo = (e = {}, t = []) => {
  const n = Z();
  return L(() => (n.current && n.current._tiptapEditor.destroy(), n.current = Do(e), n.current), t);
};
function _o() {
  const [, e] = k(0);
  return () => e((t) => t + 1);
}
const Ko = (e) => {
  const t = _o();
  E(() => {
    const n = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t();
        });
      });
    };
    return e.on("transaction", n), () => {
      e.off("transaction", n);
    };
  }, [e]);
};
var _e, xe = or;
if (process.env.NODE_ENV === "production")
  _e = xe.createRoot, xe.hydrateRoot;
else {
  var yt = xe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  _e = function(e, t) {
    yt.usingClientEntryPoint = !0;
    try {
      return xe.createRoot(e, t);
    } finally {
      yt.usingClientEntryPoint = !1;
    }
  };
}
function ve(e) {
  let t;
  const n = document.createElement("div"), i = _e(n);
  if (ir(() => {
    i.render(e((l) => t = l || void 0));
  }), !n.childElementCount)
    return console.warn("ReactInlineContentSpec: renderHTML() failed"), {
      dom: document.createElement("span")
    };
  t == null || t.setAttribute("data-tmp-find", "true");
  const a = n.cloneNode(!0), s = a.firstElementChild, u = a.querySelector(
    "[data-tmp-find]"
  );
  return u == null || u.removeAttribute("data-tmp-find"), i.unmount(), {
    dom: s,
    contentDOM: u || void 0
  };
}
function Re(e) {
  var t;
  return (
    // Creates `blockContent` element
    /* @__PURE__ */ o.jsx(
      Rt,
      {
        ...Object.fromEntries(
          Object.entries(e.domAttributes || {}).filter(
            ([n]) => n !== "class"
          )
        ),
        className: ce(
          "bn-block-content",
          ((t = e.domAttributes) == null ? void 0 : t.class) || ""
        ),
        "data-content-type": e.blockType,
        ...Object.fromEntries(
          Object.entries(e.blockProps).filter(
            ([n, i]) => !Zn.includes(n) && i !== e.propSchema[n].default
          ).map(([n, i]) => [pt(n), i])
        ),
        children: e.children
      }
    )
  );
}
function qo(e, t) {
  const n = Mt({
    name: e.type,
    content: e.content === "inline" ? "inline*" : "",
    group: "blockContent",
    selectable: !0,
    addAttributes() {
      return Et(e.propSchema);
    },
    parseHTML() {
      return Un(e, t.parse);
    },
    renderHTML() {
      const i = document.createElement("div");
      return i.setAttribute("data-tmp-placeholder", "true"), {
        dom: i
      };
    },
    addNodeView() {
      return (i) => Vt(
        (a) => {
          var h;
          const s = this.options.editor, u = $n(
            a.getPos,
            s,
            this.editor,
            e.type
          ), l = ((h = this.options.domAttributes) == null ? void 0 : h.blockContent) || {}, c = Lt({}).ref, g = t.render;
          return /* @__PURE__ */ o.jsx(
            Re,
            {
              blockType: u.type,
              blockProps: u.props,
              propSchema: e.propSchema,
              domAttributes: l,
              children: /* @__PURE__ */ o.jsx(
                g,
                {
                  block: u,
                  editor: s,
                  contentRef: c
                }
              )
            }
          );
        },
        {
          className: "bn-react-node-view-renderer"
        }
      )(i);
    }
  });
  return Wn(e, {
    node: n,
    toInternalHTML: (i, a) => {
      var c, g;
      const s = ((c = n.options.domAttributes) == null ? void 0 : c.blockContent) || {}, u = t.render, l = ve((h) => /* @__PURE__ */ o.jsx(
        Re,
        {
          blockType: i.type,
          blockProps: i.props,
          propSchema: e.propSchema,
          domAttributes: s,
          children: /* @__PURE__ */ o.jsx(
            u,
            {
              block: i,
              editor: a,
              contentRef: h
            }
          )
        }
      ));
      return (g = l.contentDOM) == null || g.setAttribute("data-editable", ""), l;
    },
    toExternalHTML: (i, a) => {
      var c, g;
      const s = ((c = n.options.domAttributes) == null ? void 0 : c.blockContent) || {}, u = t.toExternalHTML || t.render, l = ve((h) => /* @__PURE__ */ o.jsx(
        Re,
        {
          blockType: i.type,
          blockProps: i.props,
          propSchema: e.propSchema,
          domAttributes: s,
          children: /* @__PURE__ */ o.jsx(
            u,
            {
              block: i,
              editor: a,
              contentRef: h
            }
          )
        }
      ));
      return (g = l.contentDOM) == null || g.setAttribute("data-editable", ""), l;
    }
  });
}
function Po(e, t, n, i) {
  return () => (
    // Creates inline content section element
    /* @__PURE__ */ o.jsx(
      Rt,
      {
        as: "span",
        className: "bn-inline-content-section",
        "data-inline-content-type": t,
        ...Object.fromEntries(
          Object.entries(n).filter(([a, s]) => s !== i[a].default).map(([a, s]) => [pt(a), s])
        ),
        children: e
      }
    )
  );
}
function Go(e, t) {
  const n = Mt({
    name: e.type,
    inline: !0,
    group: "inline",
    selectable: e.content === "styled",
    atom: e.content === "none",
    content: e.content === "styled" ? "inline*" : "",
    addAttributes() {
      return Et(e.propSchema);
    },
    addKeyboardShortcuts() {
      return Yn(e);
    },
    parseHTML() {
      return Kn(e);
    },
    renderHTML({ node: i }) {
      const a = this.options.editor, s = ut(
        i,
        a.inlineContentSchema,
        a.styleSchema
      ), u = t.render, l = ve((c) => /* @__PURE__ */ o.jsx(u, { inlineContent: s, contentRef: c }));
      return qn(
        l,
        e.type,
        i.attrs,
        e.propSchema
      );
    },
    // TODO: needed?
    addNodeView() {
      const i = this.options.editor;
      return (a) => Vt(
        (s) => {
          const u = Lt({}).ref, l = t.render, c = Po(
            /* @__PURE__ */ o.jsx(
              l,
              {
                contentRef: u,
                inlineContent: ut(
                  s.node,
                  i.inlineContentSchema,
                  i.styleSchema
                )
              }
            ),
            e.type,
            s.node.attrs,
            e.propSchema
          );
          return /* @__PURE__ */ o.jsx(c, {});
        },
        {
          className: "bn-ic-react-node-view-renderer",
          as: "span"
          // contentDOMElementTag: "span", (requires tt upgrade)
        }
      )(a);
    }
  });
  return Gn(e, {
    node: n
  });
}
function Jo(e, t) {
  const n = nr.create({
    name: e.type,
    addAttributes() {
      return Jn(e.propSchema);
    },
    parseHTML() {
      return Qn(e);
    },
    renderHTML({ mark: i }) {
      const a = {};
      e.propSchema === "string" && (a.value = i.attrs.stringValue);
      const s = t.render, u = ve((l) => /* @__PURE__ */ o.jsx(s, { ...a, contentRef: l }));
      return Xn(
        u,
        e.type,
        i.attrs.stringValue,
        e.propSchema
      );
    }
  });
  return er(e, {
    mark: n
  });
}
export {
  Gr as AddBlockButton,
  Jr as BlockColorsButton,
  Re as BlockContentWrapper,
  Ro as BlockNoteDefaultUI,
  Uo as BlockNoteView,
  Lr as BlockTypeDropdown,
  Fr as ColorStyleButton,
  Zr as CreateLinkButton,
  eo as DefaultDragHandleMenu,
  Ur as DefaultFormattingToolbar,
  Wr as DefaultHyperlinkToolbar,
  $t as DefaultImageToolbar,
  $r as DefaultPositionedFormattingToolbar,
  Yr as DefaultPositionedHyperlinkToolbar,
  Kr as DefaultPositionedImageToolbar,
  oo as DefaultPositionedSideMenu,
  go as DefaultPositionedSuggestionMenu,
  Eo as DefaultPositionedTableHandles,
  ro as DefaultSideMenu,
  so as DefaultSuggestionMenu,
  Mo as DefaultTableHandle,
  to as DragHandle,
  Xr as DragHandleMenu,
  Gt as DragHandleMenuItem,
  _r as ImageCaptionButton,
  fo as MantineSuggestionMenu,
  uo as MantineSuggestionMenuItem,
  Nr as NestBlockButton,
  Qr as RemoveBlockButton,
  Pr as ReplaceImageButton,
  no as SideMenu,
  Kt as SideMenuButton,
  Ee as TextAlignButton,
  me as ToggledStyleButton,
  Ae as Toolbar,
  _ as ToolbarButton,
  Rr as ToolbarDropdown,
  zr as UnnestBlockButton,
  vt as applyBlockNoteCSSVariablesFromTheme,
  qo as createReactBlockSpec,
  Go as createReactInlineContentSpec,
  Jo as createReactStyleSpec,
  $o as darkDefaultTheme,
  Vr as defaultBlockTypeDropdownItems,
  C as defaultColorScheme,
  mo as filterSuggestionItems,
  bo as getDefaultReactSlashMenuItems,
  N as insertOrUpdateBlock,
  kt as lightDefaultTheme,
  Po as reactWrapInInlineContentStructure,
  Lo as removeBlockNoteCSSVariables,
  Wo as useActiveStyles,
  Yo as useBlockNote,
  io as useCloseSuggestionMenuNoItems,
  U as useEditorChange,
  Bt as useEditorContentChange,
  Ko as useEditorForceUpdate,
  Dt as useEditorSelectionChange,
  ao as useLoadSuggestionMenuItems,
  W as useSelectedBlocks,
  lo as useSuggestionMenuKeyboardNavigation,
  ko as useTableHandlesPosition
};
//# sourceMappingURL=blocknote-react.js.map
